import useEvent from './useEvent';
import useIsomorphicLayoutEffect from './useIsomorphicLayoutEffect';
import useTypedSelector from './useTypedSelector';

interface IProps {
  onFetch: () => void;
  onClear?: () => void;
  disabled?: boolean;
  changeTab: string;
}

export default function useFetchTabV4({
  onFetch: _onFetch,
  onClear: _onClear,
  disabled,
  changeTab,
}: IProps) {
  const isAppMounted = useTypedSelector(({common}) => common.isAppMounted);
  const onFetch = useEvent(_onFetch);
  const onClear = useEvent(() => _onClear?.());

  useIsomorphicLayoutEffect(() => {
    if (disabled || !isAppMounted) return;
    onFetch();
    return onClear;
  }, [disabled, isAppMounted, onFetch, onClear, changeTab]);
}
